import { Component, OnInit, inject, ViewChild } from '@angular/core';
import {
  FormGroup,
  FormControl,
  ReactiveFormsModule,
  FormBuilder,
} from '@angular/forms';
import {
  DynamicDialogModule,
  DialogService,
} from 'primeng/dynamicdialog';
import { SelectModule } from 'primeng/select';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { SearchBarComponent } from '@app/shared/components/search-bar/search-bar.component';
import { FilterItem } from '../../api/models';
import { CommonModule } from '@angular/common';
import { EmitirDocumentoModalComponent } from '../emitir-documento-modal/emitir-documento-modal.component';
import { DialogModule } from 'primeng/dialog';
import { Pagination } from '../../../../../shared/model/pagination.model';
import { TableComponent } from '@app/shared/components/table/table.component';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { Menu } from 'primeng/menu';
import { ApiService } from '@core/providers/http';
import {
  DocumentoService,
  EnumService,
  TipoDocumentoService,
} from '../../api/services';
import { TableColumn } from '../../../../../shared/components/table/table.component';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import { BackButtonComponent } from '@app/shared/components/back-button/back-button.component';
import { MessageService } from 'primeng/api';
import { Button } from 'primeng/button';
import { DatePicker } from 'primeng/datepicker';

@Component({
  selector: 'app-home-emit-document',
  templateUrl: './home-emit-document.component.html',
  styleUrls: ['./home-emit-document.component.scss'],
  imports: [
    DialogModule,
    DynamicDialogModule,
    SelectModule,
    CheckboxModule,
    Button,
    ReactiveFormsModule,
    InputTextModule,
    TableModule,
    SearchBarComponent,
    CommonModule,
    TableComponent,
    ToastModule,
    ConfirmDialogModule,
    DataVoidComponent,
    BackButtonComponent,
    DatePicker,
  ],
  providers: [
    DialogService,
    EnumService,
    ApiService,
    DocumentoService,
    ConfirmationService,
    TipoDocumentoService,
    MessageService,
  ],
})
export class HomeEmitDocumentComponent implements OnInit {
  documentoService = inject(DocumentoService);
  tipoDocumentoService = inject(TipoDocumentoService);
  enumService = inject(EnumService);
  messageService = inject(MessageService);
  constructor(private fb: FormBuilder) {}

  actions: MenuItem[] = [
    {
      label: 'Ver Documento',
      icon: 'pi pi-eye',
      command: ($event: any) => this.verDocumento($event.item?.data),
    },
    {
      label: 'Actualizar Documento',
      icon: 'pi pi-pencil',
      command: ($event: any) => this.atualizarDocumento($event.item?.data),
    },
    {
      label: 'Anular Documento',
      icon: 'pi pi-times',
      command: ($event: any) => this.anularDocumento($event.item?.data),
    },
  ];
  estadoOptions: any[] = [
    { label: 'Emitido', value: 0 },
    { label: 'Assinado', value: 1 },
    { label: 'Cancelado', value: 2 }, // novo
  ];
  @ViewChild('menu') menu!: Menu;

  visible: boolean = false;
  docsCount: any;
  formDoc!: FormGroup;

  form = new FormGroup({
    selectTypeDoc: new FormControl(null),
    doc: new FormControl([]),
    text: new FormControl(''),
  });
  pagination: Pagination<any> = new Pagination<any>();

  TypeDocs: any[] = [];
  filters: FilterItem[] = [
    {
      type: 'dropdown',
      controlName: 'TipoDocumento',
      placeholder: 'Pesquise pelo tipo de documento',
      options: this.TypeDocs,
      optionLabel: 'designacao',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'EstadoDocumento',
      placeholder: 'Estado',
      options: this.estadoOptions,
      optionLabel: 'label',
      optionValue: 'value',
    },
    {
      type: 'text',
      controlName: 'NumeroBI',
      placeholder: 'Pesquise pelo BI',
      optionLabel: 'name',
      optionValue: 'NumBI',
    },
    {
      type: 'date',
      controlName: 'DataEmissaoInicio',
      placeholder: 'Data de Emissão (início)',
    },
    {
      type: 'date',
      controlName: 'DataEmissaoFim',
      placeholder: 'Data de Emissão (fim)',
    },
    {
      type: 'text',
      controlName: 'UtilizadorID',
      placeholder: 'Pesquise pelo Utilizador ID',
    },
  ];
  // InstEnsino: City[] = [];
  // AnoCurricar: City[] = [];

  ShowSecondOption = true;
  dialogService = inject(DialogService);

  columns: TableColumn[] = [
    // { field: 'id', header: 'ID', type: 'text', tooltip: 'ID do Documento' },
    {
      field: 'tipoDocumentoDescricao',
      header: 'Tipo de Documento',
      type: 'text',
      tooltip: 'Tipo de Documento',
    },
    {
      field: 'estadoDocumentoDescricao',
      header: 'Estado',
      type: 'tag',
      severityField: 'estadoDocumento',
      tagSeverityFunction: (rowData: any) =>
        this.getSeverity(rowData.estadoDocumentoDescricao),
      tooltip: 'Estado do Documento',
    },
    {
      field: 'dataEmissao',
      header: 'Data de Emissão',
      type: 'text',
      tooltip: 'Data de Emissão',
    },
    {
      field: 'dataModificacao',
      header: 'Data de Actualização',
      type: 'text',
      tooltip: 'Data de Actualização',
    },
    // {
    //   field: 'utilizadorID',
    //   header: 'Utilizador ID',
    //   type: 'text',
    //   tooltip: 'ID do Utilizador',
    // },
  ];

  getSeverity(status: string) {
    switch (status) {
      case 'Emitido e aguardando':
        return 'info';
      case 'Assinado':
        return 'success';
      case 'Cancelado':
        return 'danger';
      case 'Carregado':
        return 'warn';
      case 'Rejeitado':
        return 'danger';
      default:
        return 'info';
    }
  }

  onActionSelected(event: any) {
    const { event: actionEvent, rowData } = event;
    this.actions
      .find((action) => action.label === actionEvent.item.label)
      ?.command?.({ item: rowData });
  }

  ngOnInit() {
    this.loadAllDocuments();
    this.getTipoDocumento();
    this.formDoc = this.fb.group({
      TipoDocumento: [null],
      EstadoDocumento: [null],
      NumeroBI: [null],
      DataEmissaoInicio: [null], // novo
      DataEmissaoFim: [null], // novo
      UtilizadorID: [null], // novo
    });
  }

  getTipoDocumento() {
    // this.tipoDocumentoService
    //   .list({ pageSize: 100 })
    //   .subscribe((response: any) => {
    //     this.TypeDocs = response.data;
    //     this.filters[0].options = this.TypeDocs;
    //   });

    this.enumService.getAllTipoDocumentoEnum().subscribe((response) => {
      if (response?.data) {
        this.TypeDocs = Object.entries(response.data).map(([key, value]) => ({
          id: Number(key),
          designacao: value,
        }));
        this.filters[0].options = this.TypeDocs;
      }
    });
  }

  toggleMenu(event: Event) {
    this.menu.toggle(event);
  }

  verDocumento(data: any) {}

  atualizarDocumento(data: any) {}

  anularDocumento(data: any) {}

  loadAllDocuments(queryParams?: any) {
    const params = {
      ...queryParams,
      pageNumber: this.pagination.pageNumber ?? 1,
      pageSize: this.pagination.pageSize ?? 10,
      OrderBy: 'id desc',
    };
    this.documentoService.list({ ...params }).subscribe(
      (response) => {
        this.pagination = new Pagination<any>().deserialize(response);
        this.docsCount = this.pagination?.totalRecords;
      },
      (error) => {
        console.error('Erro ao carregar documentos:', error);
        this.messageService.add({
          severity: 'Error',
          summary: 'Erro',
          detail: 'Erro ao buscar estudantes',
          life: 3000,
        });
      }
    );
  }

  onPageChange(event: any) {
    this.pagination.pageNumber = event.page + 1;
    this.pagination.pageSize = event.rows;
    this.loadAllDocuments();
  }

  openComprovativoSubsidioModal() {
    const ref = this.dialogService.open(EmitirDocumentoModalComponent, {
      showHeader: false,
      width: '80%',
      modal: true,
      data: {
        TypeDocs: this.TypeDocs,
      },
    });

    ref.onClose.subscribe(() => {
      console.log('Comprovativo de subsídio gerado com sucesso');
    });
  }

  showFilter = false;

  showFilterModal() {
    this.showFilter = true;
  }

  handleFormValueChange(values: Record<string, unknown>) {
    // remove nulos/vazios
    const raw: Record<string, unknown> = Object.fromEntries(
      Object.entries(values).filter(
        ([, v]) => v !== null && v !== undefined && v !== ''
      )
    );

    const toIso = (d: unknown) => (d instanceof Date ? d.toISOString() : d);

    const start = raw['DataEmissaoInicio'];
    const end = raw['DataEmissaoFim'];

    const filters: Record<string, unknown> = {
      ...raw,
      ['DataEmissaoInicio']: start ? toIso(start) : undefined,
      ['DataEmissaoFim']: end ? toIso(end) : undefined,
    };

    this.loadAllDocuments(filters);
    this.showFilter = false;
  }
}
